import i18n from "@/lang/i18n"

export const HEADER = [
  i18n.global.t('pages.auditLog.list.id'),
  i18n.global.t('pages.auditLog.list.auditableType'),
  i18n.global.t('pages.auditLog.list.event'),
  i18n.global.t('pages.auditLog.list.auditableId'),
  i18n.global.t('pages.auditLog.list.operatedUserId'),
  i18n.global.t('pages.auditLog.list.operatedUserName'),
  i18n.global.t('pages.auditLog.list.createdAt'),
  i18n.global.t('pages.auditLog.list.ipAddress'),
]

export const SELECTABLE_AUDITABLE_TYPE_ITEMS = [
  {
    name: i18n.global.t('pages.auditLog.auditableType.delivery_plan_work'),
    value: 'delivery_plan_work'
  },
  {
    name: i18n.global.t('pages.auditLog.auditableType.workload'),
    value: 'workload'
  },
  {
    name: i18n.global.t('pages.auditLog.auditableType.vehicle'),
    value: 'vehicle'
  },
  {
    name: i18n.global.t('pages.auditLog.auditableType.account'),
    value: 'account'
  },
  {
    name: i18n.global.t('pages.auditLog.auditableType.spot'),
    value: 'spot'
  },
  {
    name: i18n.global.t('pages.auditLog.auditableType.operationOffice'),
    value: 'operation_office'
  },
  {
    name: i18n.global.t('pages.auditLog.auditableType.reportLayout'),
    value: 'report_layout'
  },
]

export const SELECTABLE_EVENT_ITEMS = [
  {
    name: i18n.global.t('pages.auditLog.event.created'),
    value: 'created'
  },
  {
    name: i18n.global.t('pages.auditLog.event.updated'),
    value: 'updated'
  },
  {
    name: i18n.global.t('pages.auditLog.event.deleted'),
    value: 'deleted'
  },
]

export const AUDITABLE_TYPES = {
  'delivery_plan_work': i18n.global.t('pages.auditLog.auditableType.delivery_plan_work'),
  'workload': i18n.global.t('pages.auditLog.auditableType.workload'),
  'vehicle': i18n.global.t('pages.auditLog.auditableType.vehicle'),
  'account': i18n.global.t('pages.auditLog.auditableType.account'),
  'spot': i18n.global.t('pages.auditLog.auditableType.spot'),
  'operation_office': i18n.global.t('pages.auditLog.auditableType.operationOffice'),
  'report_layout': i18n.global.t('pages.auditLog.auditableType.reportLayout'),
};

export const ID_LABELS = {
  delivery_plan_work: i18n.global.t('pages.auditLog.list.tripId'),
  workload: i18n.global.t('pages.auditLog.list.tripId'),
  vehicle: i18n.global.t('pages.auditLog.list.id'),
  account: i18n.global.t('pages.auditLog.list.id'),
  spot: i18n.global.t('pages.auditLog.list.id'),
  operation_office: i18n.global.t('pages.auditLog.list.id'),
  report_layout: i18n.global.t('pages.auditLog.list.id'),
}
